import { getCookie, getQueryString } from './helper';

function inGenders(gender) {
  const genders = ['male', 'female', 'together', 'etc'];

  if (genders.indexOf(gender) !== -1) {
    return gender;
  } else {
    return '';
  }
}

const camsconSession = getCookie('camscon');

const headers = {
  'Client-Type': 'webapp',
  'Accept': 'application/json',
  'Access-Control-Allow-Origin': process.browser? document.location.host :''
};

camsconSession && (headers.Authorization = `Bearer ${ camsconSession }`);

let host, fbKey, kakaoKey, localStorageKey;
let hostURL = 'https://api.camscon.kr';
// let hostURL = 'http://localhost:8000';
if (true) {
  // host = (process.env.NODE_ENV && (process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'development')) ? `https://api.camscon.kr/v1` : `https://api-dev.camscon.kr/v1`;
  host = (process.env.NODE_ENV && (process.env.NODE_ENV === 'production')) ? `${hostURL}/v1` : `https://api-dev.camscon.kr/v1`;
  fbKey = (process.env.NODE_ENV && (process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'test')) ? `562009567255774` : `1111652778888071`;
  kakaoKey = (process.env.NODE_ENV && (process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'test')) ? `8c196f82159b462d6611bb365f5ed049` : `4a5607f2dc1622d91b7137fff35a464d`;
  localStorageKey = process.env.NODE_ENV ? `camscon-${ process.env.NODE_ENV }` : 'camscon';

  host = hostURL+'/v1';
  fbKey = '562009567255774';
  kakaoKey = '8c196f82159b462d6611bb365f5ed049';
  localStorageKey = 'camscon-production';
} else {
  host = hostURL+'/v1';
  fbKey = `562009567255774`;
  kakaoKey = `8c196f82159b462d6611bb365f5ed049`;
  localStorageKey = 'camscon';
}

const defaultStates = {
  /**
   * 공통 사용 props
   *
   * @headers {Object} : CORS 관련 객체
   * Accept (Required), Access-Control-Allow-Origin (Required) 와 Authorization (Optional), Client-Type (Optional) 이 포함된 객체
   */
  headers: headers,
  host: host,
  kakaoKey: kakaoKey,
  fbKey: fbKey,
  localStorageKey: localStorageKey,
  me: null,
  // session: '',
  // loggedAt: +new Date(),
  camsconViewCount: process.browser? +localStorage.getItem('camsconViewCount') || 0:0,

  /**
   * Banner 관련 Props
   */
  banners: [],

  /**
   * GNB 메뉴 관련 Props
   *
   * @menues    {Array}  : 1-뎁스 메뉴
   * @menuItmes {Object} : 2-뎁스 메뉴
   */
  menus: [
    'Campus', 'Street', 'Fashion Week', 'Festival', 'Beach/Waterpark', 'Magazines', 'Blogger', 'Models', 'Brands'
  ],
  menuItems: {
    bloggers: [
      { key: 'kr', title: 'Korea', kr: [ { bloggerName: '날아', slug: '날아', image: '/assets/images/1.jpg' }, { bloggerName: '노루살롱', slug: '노루살롱', image: '/assets/images/1.jpg' }, { bloggerName: '다쉐로그', slug: '다쉐로그', image: '/assets/images/1.jpg' }, { bloggerName: '딘디', slug: '딘디', image: '/assets/images/1.jpg' }, { bloggerName: '딥브로우', slug: '딥브로우', image: '/assets/images/1.jpg' }, { bloggerName: '로맨티치', slug: '로맨티치', image: '/assets/images/1.jpg' }, { bloggerName: '류경아', slug: '류경아', image: '/assets/images/1.jpg' }, { bloggerName: '미니', slug: '미니', image: '/assets/images/1.jpg' }, { bloggerName: '보그리', slug: '보그리', image: '/assets/images/1.jpg' }, { bloggerName: '비바 에이브릴', slug: '비바에이브릴', image: '/assets/images/1.jpg' }, { bloggerName: '비비드 플레이스', slug: '비비드플레이스', image: '/assets/images/1.jpg' }, { bloggerName: '지몬', slug: '지몬', image: '/assets/images/1.jpg' }, { bloggerName: 'S\'GANG ZONE', slug: 'sgangzone', image: '/assets/images/1.jpg' }, { bloggerName: 'SHE\'S CLOTHES', slug: 'shesclothes', image: '/assets/images/1.jpg' }, { bloggerName: 'SYUK YIA', slug: 'syukyia', image: '/assets/images/1.jpg' }, { bloggerName: 'AKE', slug: 'ake', image: '/assets/images/1.jpg' }, { bloggerName: '우기클로짓', slug: '우기클로짓', image: '/assets/images/1.jpg' }, { bloggerName: 'Yunique Zone', slug: 'yuniquezone', image: '/assets/images/1.jpg' }, { bloggerName: '윤위즈덤', slug: '윤위즈덤', image: '/assets/images/1.jpg' }, { bloggerName: '뒹굴뒹굴', slug: '뒹굴뒹굴', image: '/assets/images/1.jpg' }, { bloggerName: 'SOOM IN', slug: 'sommin', image: '/assets/images/1.jpg' }, { bloggerName: '써나', slug: '써나', image: '/assets/images/1.jpg' }, { bloggerName: '연화', slug: '연화', image: '/assets/images/1.jpg' }, { bloggerName: '0서', slug: '0서', image: '/assets/images/1.jpg' }, { bloggerName: ' 윤긍정', slug: '윤긍정', image: '/assets/images/1.jpg' }, { bloggerName: '이까까', slug: '이까까', image: '/assets/images/1.jpg' }, { bloggerName: '18360', slug: '18360', image: '/assets/images/1.jpg' }, { bloggerName: '이지룩', slug: '이지룩', image: '/assets/images/1.jpg' }, { bloggerName: 'jaQjo y', slug: 'jaqjoy', image: '/assets/images/1.jpg' }, { bloggerName: '조돌월드', slug: '조돌월드', image: '/assets/images/1.jpg' }, { bloggerName: '주낭', slug: '주낭', image: '/assets/images/1.jpg' }, { bloggerName: '준햄', slug: '준햄', image: '/assets/images/1.jpg' }, { bloggerName: '지니핏', slug: '지니핏', image: '/assets/images/1.jpg' }, { bloggerName: 'CHIMICLASSIC PI', slug: 'chimiclassicpi', image: '/assets/images/1.jpg' }, { bloggerName: '포레드', slug: '포레드', image: '/assets/images/1.jpg' }, { bloggerName: 'HINEOH', slug: 'hineoh', image: '/assets/images/1.jpg' },
        { bloggerName: 'HEY', slug: 'hey', image: '/assets/images/1.jpg' }, { bloggerName: '황시카', slug: '황시카', image: '/assets/images/1.jpg' }, { bloggerName: 'My Blonde Gal', slug: 'myblondegal', image: '/assets/images/1.jpg' }, { bloggerName: '258', slug: '258', image: '/assets/images/1.jpg' }, { bloggerName: '새브리', slug: '새브리', image: '/assets/images/1.jpg' } ] },
      { key: 'er', title: 'Europe', er: [ { bloggerName: 'All around my world', slug: 'allaroundmyworld', image: '/assets/images/1.jpg' }, { bloggerName: 'BLANKA', slug: 'blanka', image: '/assets/images/1.jpg' }, { bloggerName: 'BORASIFICATION', slug: 'borasification', image: '/assets/images/1.jpg' }, { bloggerName: 'CITY FASHION FOOD', slug: 'cityfashionfood', image: '/assets/images/1.jpg' }, { bloggerName: 'Dream Love Shop', slug: 'dreamloveshop', image: '/assets/images/1.jpg' }, { bloggerName: 'Ebba Zingmark', slug: 'ebbazingmark', image: '/assets/images/1.jpg' }, { bloggerName: 'Fashion Zen', slug: 'fashionzen', image: '/assets/images/1.jpg' }, { bloggerName: 'J\'adore Fashion', slug: 'jadorefasion', image: '/assets/images/1.jpg' }, { bloggerName: 'KATIQUETTE', slug: 'katiquette', image: '/assets/images/1.jpg' }, { bloggerName: 'Mikko Puttonen', slug: 'mikkoputtonen', image: '/assets/images/1.jpg' }, { bloggerName: 'NO ME VENDAS LA MOTO', slug: 'nomevendaslamoto', image: '/assets/images/1.jpg' }, { bloggerName: 'OVIDIJUS MASLOVAS', slug: 'ovidijusmaslovas', image: '/assets/images/1.jpg' }, { bloggerName: 'Rozalia Fashion', slug: 'rozaliafasion', image: '/assets/images/1.jpg' }, { bloggerName: 'Septembrenell', slug: 'septembrenell', image: '/assets/images/1.jpg' }, { bloggerName: 'Serial Klother', slug: 'serialklother', image: '/assets/images/1.jpg' }, { bloggerName: 'Simple et chic', slug: 'simpleetchic', image: '/assets/images/1.jpg' }, { bloggerName: 'Stylnoxe', slug: 'stylnoxe', image: '/assets/images/1.jpg' }, { bloggerName: 'THE CAB LOOK', slug: 'thecablook', image: '/assets/images/1.jpg' }, { bloggerName: 'The Hallowed Ground', slug: 'thehallowedground', image: '/assets/images/1.jpg' }, { bloggerName: 'TINI TANI', slug: 'tinitani', image: '/assets/images/1.jpg' }, { bloggerName: 'VIOLET ELL', slug: 'violetell', image: '/assets/images/1.jpg' } ] },
      { key: 'as', title: 'Asia', as: [ { bloggerName: 'Camille Co', slug: 'camilleco', image: '/assets/images/1.jpg' }, { bloggerName: 'Se7en', slug: 'se7en', image: '/assets/images/1.jpg' }, { bloggerName: 'ZI QIANG', slug: 'ziqiang', image: '/assets/images/1.jpg' } ] },
      { key: 'oc', title: 'Oceania', oc: [ { bloggerName: 'BAM IT\'S JOANNE', slug: 'bamitsjoanne', image: '/assets/images/1.jpg' }, { bloggerName: 'CHLOE CHILL', slug: 'chloechill', image: '/assets/images/1.jpg' }, { bloggerName: 'CHLOE TING', slug: 'chloeting', image: '/assets/images/1.jpg' }, { bloggerName: 'Elle-May', slug: 'ellemay', image: '/assets/images/1.jpg' } ] },
      { key: 'na', title: 'North America', na: [ { bloggerName: 'avant lard', slug: 'avantlard', image: '/assets/images/1.jpg' }, { bloggerName: 'BEST BEFORE', slug: 'bestbefore', image: '/assets/images/1.jpg' }, { bloggerName: 'CASHMERE & ROSES', slug: 'cashmereroses', image: '/assets/images/1.jpg' }, { bloggerName: 'FASHIONLUSH', slug: 'fashionlush', image: '/assets/images/1.jpg' }, { bloggerName: 'HELL HOUND, HELL BOUND', slug: 'hellhoundhellbound', image: '/assets/images/1.jpg' }, { bloggerName: 'Jullianne', slug: 'jullianne', image: '/assets/images/1.jpg' }, { bloggerName: 'Late Afternoon Blog', slug: 'lateafternoonblog', image: '/assets/images/1.jpg' }, { bloggerName: 'THE RUBY ELEMENT', slug: 'therubyelement', image: '/assets/images/1.jpg' }, { bloggerName: 'Treats and Treasures', slug: 'treatsandtreasures', image: '/assets/images/1.jpg' } ] }
    ],
    beach: [
      '경포대', '오션월드', '캐리비안 베이', '한강시민공원', '해밀톤호텔', '해운대'
    ],
    brands: [
      { key: 'spa', title: 'SPA', spa: [
        { brandName: '8 Seconds', slug: '8seconds', image: '/assets/images/gnb/brand/eightseconds.jpg' },
        { brandName: 'Bershka', slug: 'bershka', image: '/assets/images/gnb/brand/bershka.jpg' },
        { brandName: 'Forever 21', slug: 'forever21', image: '/assets/images/gnb/brand/forever21.jpg' },
        { brandName: 'H&M', slug: 'hnm', image: '/assets/images/gnb/brand/H&M.jpg' },
        { brandName: 'SPAO', slug: 'spao', image: '/assets/images/gnb/brand/SPAO.jpg' },
        { brandName: 'Topten', slug: 'topten', image: '/assets/images/gnb/brand/TOPTEN.jpg' },
        { brandName: 'Uniqlo', slug: 'uniqlo', image: '/assets/images/gnb/brand/UNIQLO.jpg' },
        { brandName: 'ZARA', slug: 'zara', image: '/assets/images/gnb/brand/ZARA.jpg' },
			] },
      { key: 'spo', title: '스포츠', spo: [
        { brandName: 'Adidas', slug: 'adidas', image: '/assets/images/gnb/brand/ADIDAS.jpg' },
        { brandName: 'Asics', slug: 'asics', image: '/assets/images/gnb/brand/ASICS.jpg' },
        { brandName: 'Descente', slug: 'descente', image: '/assets/images/gnb/brand/DESCENTE.jpg' },
        { brandName: 'FILA', slug: 'fila', image: '/assets/images/gnb/brand/FILA.jpg' },
        { brandName: 'Lecoq', slug: 'lecoqsportif', image: '/assets/images/gnb/brand/LECOQ.jpg' },
        { brandName: 'New Balance', slug: 'newbalance', image: '/assets/images/gnb/brand/NEW BALANCE.jpg' },
        { brandName: 'Nike', slug: 'nike', image: '/assets/images/gnb/brand/NIKE.jpg' },
        { brandName: 'Puma', slug: 'puma', image: '/assets/images/gnb/brand/PUMA.jpg' },
        { brandName: 'Reebok', slug: 'Reebok', image: '/assets/images/gnb/brand/REEBOK.jpg' },
        { brandName: 'Umbro', slug: 'umbro', image: '/assets/images/gnb/brand/UMBRO.jpg' },
      ] },
      { key: 'cas', title: '캐쥬얼', cas: [
				{ brandName: 'Americal Apperal', slug: 'americanapparel', image: '/assets/images/gnb/brand/AMERICAN APPAREL.jpg' },
				{ brandName: 'Basic House', slug: 'basichouse', image: '/assets/images/gnb/brand/basichouse.jpg' },
				{ brandName: 'Bean Pole', slug: 'beanpole', image: '/assets/images/gnb/brand/BEANPOLE.jpg' },
				{ brandName: 'Lacoste', slug: 'lacoste', image: '/assets/images/gnb/brand/LACOSTE.jpg' },
				{ brandName: 'Lucky Chouette', slug: 'luckychouette', image: '/assets/images/gnb/brand/luckychouette.jpg' },
				{ brandName: 'POLHAM', slug: 'polham', image: '/assets/images/gnb/brand/POLHAM.jpg' },
				{ brandName: 'Tomboy', slug: 'tomboy', image: '/assets/images/gnb/brand/TOMBOY.jpg' },
      ] },
      { key: 'man', title: '남성', man: [
        { brandName: 'T.I.For Men', slug: 'tiformen', image: '/assets/images/gnb/brand/T.I.FOR MEN.jpg' },
        { brandName: 'ZIOZIA', slug: 'ziozia', image: '/assets/images/gnb/brand/ZIOZIA.jpg' },
				{ brandName: 'Customellow', slug: 'customellow', image: '/assets/images/gnb/brand/CUSTOMELLOW.jpg' },
        { brandName: 'The class', slug: 'theclass', image: '/assets/images/gnb/brand/theclass.png' },
      ] },
      { key: 'str', title: '스트릿', str: [
        { brandName: 'Brown Breath', slug: 'brownbreath', image: '/assets/images/gnb/brand/BROWN BREATH.jpg' },
				{ brandName: 'Carhartt', slug: 'carhartt', image: '/assets/images/gnb/brand/CARHARTT.jpg' },
        { brandName: 'Champion', slug: 'champion', image: '/assets/images/gnb/brand/CHAMPION.jpg' },
				{ brandName: 'CRITIC', slug: 'critic', image: '/assets/images/gnb/brand/CRITIC.jpg' },
				{ brandName: 'Liful', slug: 'liful', image: '/assets/images/gnb/brand/LIFUL.jpg' },
        { brandName: 'This is never That', slug: 'thisisneverthat', image: '/assets/images/gnb/brand/THIS IS NEVER THAT .jpg' },
      ] },
      { key: 'des', title: '디자이너', des: [
				{ brandName: 'Beyond Closet', slug: 'beyondcloset', image: '/assets/images/gnb/brand/BEYOND CLOSET.jpg' },
        { brandName: 'CHARM\'S', slug: 'charms', image: '/assets/images/gnb/brand/CHARMS.jpg' },
        { brandName: 'DIM.E.CRES.', slug: 'dimecres', image: '/assets/images/gnb/brand/DIM.E.CRES..jpg' },
				{ brandName: 'Low Classic', slug: 'lowclassic', image: '/assets/images/gnb/brand/LOW CLASSIC.jpg' },
        { brandName: 'Mis Chief', slug: 'mischief', image: '/assets/images/gnb/brand/MiscHIEF.jpg' },
        { brandName: 'Munsoo Kwon', slug: 'munsookwon', image: '/assets/images/gnb/brand/MUNSOOKWON.jpg' },
        { brandName: 'OiOi', slug: 'oioi', image: '/assets/images/gnb/brand/OiOi.jpg' },
        { brandName: 'Ordinary People', slug: 'ordinarypeople', image: '/assets/images/gnb/brand/ORDINARY PEOPLE.jpg' },
        { brandName: 'Push Button', slug: 'pushbutton', image: '/assets/images/gnb/brand/PUSH BUTTON.jpg' },
        { brandName: 'Rocket X Lunch', slug: 'rocketxlunch', image: '/assets/images/gnb/brand/ROCKET X RUNCH.jpg' },
        { brandName: 'Sewing Boundaries', slug: 'sewingboundaries', image: '/assets/images/gnb/brand/SEWING BOUNDARIES.jpg' },
      ] },
      { key: 'sho', title: '신발', sho: [
        { brandName: 'Converse', slug: 'converse', image: '/assets/images/gnb/brand/CONVERSE.jpg' },
        { brandName: 'VANS', slug: 'vans', image: '/assets/images/gnb/brand/VANS.jpg' },
        { brandName: 'Dr.Martens', slug: 'drmartens', image: '/assets/images/gnb/brand/DR.MARTENS.jpg' },
        { brandName: 'Timberland', slug: 'timberland', image: '/assets/images/gnb/brand/TIMBERLAND.jpg' },
      ] },
      { key: 'acc', title: '악세사리', acc: [
        { brandName: 'Freitag', slug: 'freitag', image: '/assets/images/gnb/brand/FREITAG.jpg' },
        { brandName: 'Gentle Monster', slug: 'gentlemonster', image: '/assets/images/gnb/brand/GENTLE MONSTER.jpg' },
      ] },
      { key: 'mal', title: '쇼핑몰', mal: [
        { brandName: 'Style Nanda', slug: 'stylenanda', image: '/assets/images/gnb/brand/STYLE NANDA.jpg' },
      ] }
    ],
    campuses: [
      { key: 'ga', title: '가', ga: [ '가천대', '가톨릭대', '강남대', '강릉원주대', '강원대', '건국대', '건국대(글로컬)', '건양대', '경기대', '경민대', '경북대', '경상대', '경성대', '경인교대', '경일대', '경찰대학', '경희대', '경희대 (국제)', '계명대', '계원예대', '고려대', '고려대(세종)', '공군사관학교', '공주대', '광운대', '광주대', '국민대', '국제패션학교', '금오공과대' ] },
      { key: 'na', title: '나', na: [ '남부대', '남서울대', '노인대학' ] },
      { key: 'da', title: '다', da: [ '단국대', '단국대(천안)', '대구가톨릭대', '대구대', '대전대', '대진대', '덕성여대', '동국대', '동국대(경주)', '동덕여대', '동명대', '동서대', '동아대', '동아방송예술대', '동양대', '동양미래대', '동원대', '동의대' ] },
      { key: 'la', title: '라', la: [ '라사라패션학교' ] },
      { key: 'ma', title: '마', ma: [ '명지대', '목원대' ] },
      { key: 'ba', title: '바', ba: [ '배재대', '배화여대', '백석대', '부경대', '부산가톨릭대', '부산경상대', '부산대', '부산외대' ] },
      { key: 'sa', title: '사', sa: [ '삼육대', '삼성디자인스쿨', '상명대', '상명대(천안)', '상지대', '서강대', '서경대', '서울과기대', '서울교대', '서울대', '서울모드패션학교', '서울시립대', '서울여대', '서울예대', '서울예술전문학교', '서울종합예술학교', '서원대', '성균관대', '성신여대', '세종대', '수원대', '수원여대', '숙명여대', '순천대', '순천향대', '숭실대', '숭의여대', '신구대', '신라대', '신성대', '신한대' ] },
      { key: 'a', title: '아', a: [ '아주대', '안동대', '안양대', '에스모드패션학교', '연성대', '연세대', '연세대(원주)', '영남대', '영동대', '용인대', '용인송담대', '우송대', '울산대', '원광대', '유니스트', '육군사관학교', '을지대', '이화여대', '인천대', '인하공업전문대학', '인하대' ] },
      { key: 'ja', title: '자', ja: [ '전남대', '전북대', '전주대', '제주대', '조선대', '중부대', '중앙대', '중앙대(안성)' ] },
      { key: 'cha', title: '차', cha: [ '창원대', '청강문화산업대', '청주대', '청운대', '충남대', '충북대' ] },
      { key: 'ka', title: '카', ka: [ '카이스트' ] },
      { key: 'ta', title: '타', ta: [ '' ] },
      { key: 'pa', title: '파', pa: [ '평택대', '포항공대' ] },
      { key: 'ha', title: '하', ha: [ '한경대', '한국교통대', '한국기술교육대', '한국산기대', '한국영상대', '한국외대', '한국외대(글로벌)', '한국체대', '한국항공대', '한국해양대', '한남대', '한동대', '한림대', '한밭대', '한서대', '한성대', '한세대', '한신대', '한양대', '한양대(ERICA)', '한양여대', '한예종', '해군사관학교', '협성대', '호서대', '홍익대', '홍익대(세종)' ]},
    ],
    fashionWeeks: [
      '18 F／W 서울패션위크', '18 S／S 서울패션위크', '17 F／W 서울패션위크', '17 S／S 서울패션위크',
      '16 F／W 서울패션위크', '16 S／S 서울패션위크', '16 S／S 파리패션위크', '16 S／S 밀란패션위크',
      '16 S／S 뉴욕패션위크', '16 S／S 런던패션위크', '16 S／S 상하이패션위크', '15 F／W 서울패션위크',
      '15 F／W 파리패션위크', '15 S／S 서울패션위크', '15 S／S 뉴욕패션위크', '14 S／S 서울패션위크',
      '13 F／W 서울패션위크', '13 F／W 뉴욕패션위크'
    ],
    festivals: [
      // INSPIRED NIGHT, 서울 패션 페스티벌, 스펙트럼, 워터밤
      'CAMSCON Inspired Night', 'GO OUT CAMP', 'RAPBEAT SHOW', '그랜드민트 페스티벌', '그린플러그드서울', '글로벌개더링코리아',
      '레인보우아일랜드', '서울재즈페스티벌', '서울 패션페스티벌', '스펙트럼', '울트라 뮤직 페스티벌', '워터밤 페스티벌', '월드 DJ 페스티벌',
      '자라섬 재즈 페스티벌', '지산 밸리록 페스티벌', '펜타포트 락페스티벌', '하이네켄 스타디움', '힙합플레이야 페스티벌'
    ],
    magazines: [
      { image: '/assets/images/gnb/magazine/캠스콘.jpg', magazineName: 'CAMSCON', slug: 'camscon', },
      { image: '/assets/images/gnb/magazine/1st LOOK.jpg', magazineName: '1st Look', slug: '1stlook', },
      { image: '/assets/images/gnb/magazine/allure.jpg', magazineName: 'ALLURE', slug: 'allure', },
      { image: '/assets/images/gnb/magazine/ARENA.jpg', magazineName: 'ARENA', slug: 'arena' },
      { image: '/assets/images/gnb/magazine/BLING.jpg', magazineName: 'BLING', slug: 'blink', },
      { image: '/assets/images/gnb/magazine/CECI.jpg', magazineName: 'CECI', slug: 'ceci', },
      { image: '/assets/images/gnb/magazine/COSMOPOLITAN.jpg', magazineName: 'COSMOPOLITAN', slug: 'cosmopolitan', },
      { image: '/assets/images/gnb/magazine/DAZED.jpg', magazineName: 'DAZED', slug: 'dazed', },
      { image: '/assets/images/gnb/magazine/ESQUIRE.jpg', magazineName: 'ESQUIRE', slug: 'esquire', },
      { image: '/assets/images/gnb/magazine/gq.jpg', magazineName: 'GQ', slug: 'gq', },
      { image: '/assets/images/gnb/magazine/GRAZIA.jpg', magazineName: 'GRAZIA', slug: 'grazia', },
      { image: '/assets/images/gnb/magazine/HARPER\'S BAZAAR.jpg', magazineName: 'HAPER\'S BAZAAR', slug: 'hapersbazaar', },
      { image: '/assets/images/gnb/magazine/HIGH CUT.jpg', magazineName: 'HIGH CUT', slug: 'highcut', },
      { image: '/assets/images/gnb/magazine/HIPHOPER.jpg', magazineName: 'HIPHOPER', slug: 'hiphoper', },
      { image: '/assets/images/gnb/magazine/InStyle.jpg', magazineName: 'InStyle', slug: 'instyle', },
      { image: '/assets/images/gnb/magazine/LOFFICIEL HOMMES.jpg', magazineName: 'L\'Officiel Hommes', slug: 'lofficielhommes', },
      { image: '/assets/images/gnb/magazine/MUSINSA.jpg', magazineName: 'MUSINSA', slug: 'musinsa', },
      { image: '/assets/images/gnb/magazine/NYLON.jpg', magazineName: 'NYLON', slug: 'nylon', },
      { image: '/assets/images/gnb/magazine/SURE.jpg', magazineName: 'SURE', slug: 'sure', },
      { image: '/assets/images/gnb/magazine/VOGUE.jpg', magazineName: 'VOGUE', slug: 'vogue', },
      { image: '/assets/images/gnb/magazine/W.jpg', magazineName: 'W', slug: 'w', },
    ],
    models: [
      { key: 'm', title: '남자', m: [
				{ modelName: '강희', image: '/assets/images/gnb/model-m/강희.jpg', slug: 'kanghee', },
				{ modelName: '권현빈', image: '/assets/images/gnb/model-m/권현빈.jpg', slug: 'kwonhyeonbin', },
				{ modelName: '김기범', image: '/assets/images/gnb/model-m/김기범.jpg', slug: 'kimkibum', },
				{ modelName: '김도진', image: '/assets/images/gnb/model-m/김도진.jpg', slug: 'kimdojin', },
				{ modelName: '김민종', image: '/assets/images/gnb/model-m/김민종.jpg', slug: 'kimminjong', },
				{ modelName: '김원중', image: '/assets/images/gnb/model-m/김원중.jpg', slug: 'wonjoongkim', },
				{ modelName: '김태환', image: '/assets/images/gnb/model-m/김태환.jpg', slug: 'kimtaehwan', },
				{ modelName: '남주혁', image: '/assets/images/gnb/model-m/남주혁.jpg', slug: 'namjuhyeok', },
				{ modelName: '민준기', image: '/assets/images/gnb/model-m/민준기.jpg', slug: 'minjunki', },
				{ modelName: '박경진', image: '/assets/images/gnb/model-m/박경진.jpg', slug: 'parkkyungjin', },
				{ modelName: '박성진', image: '/assets/images/gnb/model-m/박성진.jpg', slug: 'parksungjin', },
				{ modelName: '박유리', image: '/assets/images/gnb/model-m/박유리.jpg', slug: 'parkyuri', },
				{ modelName: '박지운', image: '/assets/images/gnb/model-m/박지운.jpg', slug: 'parkjiwoon', },
				{ modelName: '박형섭', image: '/assets/images/gnb/model-m/박형섭.jpg', slug: 'parkhyungseop', },
				{ modelName: '방주호', image: '/assets/images/gnb/model-m/방주호.jpg', slug: 'bankjooho', },
				{ modelName: '변우석', image: '/assets/images/gnb/model-m/변우석.jpg', slug: 'byunwoosub', },
				{ modelName: '신용국', image: '/assets/images/gnb/model-m/신용국.jpg', slug: 'shinyongkook', },
				{ modelName: '신재혁', image: '/assets/images/gnb/model-m/신재혁.jpg', slug: 'shinjaehyuk', },
				{ modelName: '안승준', image: '/assets/images/gnb/model-m/안승준.jpg', slug: 'ansungjoon', },
				{ modelName: '윤정재', image: '/assets/images/gnb/model-m/윤정재.jpg', slug: 'yunjungjae', },
				{ modelName: '이봄찬', image: '/assets/images/gnb/model-m/이봄찬.jpg', slug: 'leebomchan', },
				{ modelName: '이의수', image: '/assets/images/gnb/model-m/이의수.jpg', slug: 'leeeesu', },
				{ modelName: '이철우', image: '/assets/images/gnb/model-m/이철우.jpg', slug: 'leechulwoo', },
				{ modelName: '이현준', image: '/assets/images/gnb/model-m/이현준.jpg', slug: 'leehyunjun', },
				{ modelName: '이호연', image: '/assets/images/gnb/model-m/이호연.jpg', slug: 'leehoyun', },
				{ modelName: '이희수', image: '/assets/images/gnb/model-m/이희수.jpg', slug: 'leeheesu', },
				{ modelName: '장기용', image: '/assets/images/gnb/model-m/장기용.jpg', slug: 'jangkiyong', },
				{ modelName: '장성훈', image: '/assets/images/gnb/model-m/장성훈.jpg', slug: 'jangsunghoon', },
				{ modelName: '정용수', image: '/assets/images/gnb/model-m/정용수.jpg', slug: 'jungyongsu', },
				{ modelName: '정혁', image: '/assets/images/gnb/model-m/정혁.jpg', slug: 'junghyeok', },
				{ modelName: '조민호', image: '/assets/images/gnb/model-m/조민호.jpg', slug: 'chominho', },
				{ modelName: '주우재', image: '/assets/images/gnb/model-m/주우재.jpg', slug: 'joowoojae', },
				{ modelName: '한승수', image: '/assets/images/gnb/model-m/한승수.jpg', slug: 'hansengsu', }
			] },
      { key: 'f', title: '여자', f: [
				{ modelName: '강소영', image: '/assets/images/gnb/model-f/강소영.jpg', slug: 'kangsoyeong', },
				{ modelName: '강승현', image: '/assets/images/gnb/model-f/강승현.jpg', slug: 'kanghyoni', },
				{ modelName: '강희', image: '/assets/images/gnb/model-f/강희.jpg', slug: 'kanghee', },
				{ modelName: '고소현', image: '/assets/images/gnb/model-f/고소현.jpg', slug: 'kosokyun', },
				{ modelName: '권지야', image: '/assets/images/gnb/model-f/권지야.jpg', slug: 'kwonjeeya', },
				{ modelName: '김나래', image: '/assets/images/gnb/model-f/김나래.jpg', slug: 'kimnarae', },
				{ modelName: '김로사', image: '/assets/images/gnb/model-f/김로사.jpg', slug: 'kimrosa', },
				{ modelName: '김명진', image: '/assets/images/gnb/model-f/김명진.jpg', slug: 'kimmyungjin', },
				{ modelName: '김설희', image: '/assets/images/gnb/model-f/김설희.jpg', slug: 'kimseolhee', },
				{ modelName: '김승희', image: '/assets/images/gnb/model-f/김승희.jpg', slug: 'kimseunghee', },
				{ modelName: '김예림', image: '/assets/images/gnb/model-f/김예림.jpg', slug: 'kimyerim', },
				{ modelName: '김은해', image: '/assets/images/gnb/model-f/김은해.jpg', slug: 'kimeunhye', },
				{ modelName: '김진경', image: '/assets/images/gnb/model-f/김진경.jpg', slug: 'kimjinkyung', },
				{ modelName: '김혜아', image: '/assets/images/gnb/model-f/김혜아.jpg', slug: 'kimhyeya', },
				{ modelName: '배윤영', image: '/assets/images/gnb/model-f/배윤영.jpg', slug: 'badyoonyoung', },
				{ modelName: '송해나', image: '/assets/images/gnb/model-f/송해나.jpg', slug: 'songhaena', },
				{ modelName: '송해인', image: '/assets/images/gnb/model-f/송해인.jpg', slug: 'songhaein', },
				{ modelName: '스테파니 리', image: '/assets/images/gnb/model-f/스테파니리.jpg', slug: 'leestephanie', },
				{ modelName: '신해남', image: '/assets/images/gnb/model-f/신해남.jpg', slug: 'shinhaenam', },
				{ modelName: '신현지', image: '/assets/images/gnb/model-f/신현지.jpg', slug: 'shinhyunji', },
				{ modelName: '신혜진', image: '/assets/images/gnb/model-f/신혜진.jpg', slug: 'shinhyejin', },
				{ modelName: '심소영', image: '/assets/images/gnb/model-f/심소영.jpg', slug: 'shimsoyoung', },
				{ modelName: '아이린', image: '/assets/images/gnb/model-f/아이린.jpg', slug: 'irene', },
				{ modelName: '안아름', image: '/assets/images/gnb/model-f/안아름.jpg', slug: 'ahnareum', },
				{ modelName: '안예림', image: '/assets/images/gnb/model-f/안예림.jpg', slug: 'ahnyerim', },
				{ modelName: '안예원', image: '/assets/images/gnb/model-f/안예원.jpg', slug: 'ahnyewon', },
				{ modelName: '엄예진', image: '/assets/images/gnb/model-f/엄예진.jpg', slug: 'umyejin', },
				{ modelName: '엄유정', image: '/assets/images/gnb/model-f/엄유정.jpg', slug: 'umyoojung', },
				{ modelName: '엘리스', image: '/assets/images/gnb/model-f/엘리스.jpg', slug: 'alice', },
				{ modelName: '여연희', image: '/assets/images/gnb/model-f/여연희.jpg', slug: 'yeoyeonhee', },
				{ modelName: '여혜원', image: '/assets/images/gnb/model-f/여혜원.jpg', slug: 'yeohyewon', },
				{ modelName: '윤소정', image: '/assets/images/gnb/model-f/윤소정.jpg', slug: 'yoonsojung', },
				{ modelName: '이성경', image: '/assets/images/gnb/model-f/이성경.jpg', slug: 'leesungkyung', },
				{ modelName: '이진이', image: '/assets/images/gnb/model-f/이진이.jpg', slug: 'leejinlee', },
				{ modelName: '이호정', image: '/assets/images/gnb/model-f/이호정.jpg', slug: 'leehojeong', },
				{ modelName: '장윤주', image: '/assets/images/gnb/model-f/장윤주.jpg', slug: 'jangyoonju', },
				{ modelName: '정소현', image: '/assets/images/gnb/model-f/정소현.jpg', slug: 'jungsohyun', },
				{ modelName: '정채율', image: '/assets/images/gnb/model-f/정채율.jpg', slug: 'jungchaeyool', },
				{ modelName: '정호연', image: '/assets/images/gnb/model-f/정호연.jpg', slug: 'junghoyeon', },
				{ modelName: '조은서', image: '/assets/images/gnb/model-f/조은서.jpg', slug: 'choeunseo', },
				{ modelName: '주선영', image: '/assets/images/gnb/model-f/주선영.jpg', slug: 'joosunyoung', },
				{ modelName: '지이수', image: '/assets/images/gnb/model-f/지이수.jpg', slug: 'jeeleesu', },
				{ modelName: '진정선', image: '/assets/images/gnb/model-f/진정선.jpg', slug: 'jinjungsun', },
				{ modelName: '최소라', image: '/assets/images/gnb/model-f/최소라.jpg', slug: 'choisora', },
				{ modelName: '최준영', image: '/assets/images/gnb/model-f/최준영.jpg', slug: 'choijoonyoung', },
				{ modelName: '한경연', image: '/assets/images/gnb/model-f/한경연.jpg', slug: 'hankyounghyeon', },
				{ modelName: '한예지', image: '/assets/images/gnb/model-f/한예지.jpg', slug: 'hanyeji', },
				{ modelName: '한혜진', image: '/assets/images/gnb/model-f/한혜진.jpg', slug: 'hanhyejin', },
				{ modelName: '황기쁨', image: '/assets/images/gnb/model-f/황기쁨.jpg', slug: 'hwanggibbeum', },
				{ modelName: '황세온', image: '/assets/images/gnb/model-f/황세온.jpg', slug: 'hwangseon', },
				{ modelName: '황현주', image: '/assets/images/gnb/model-f/황현주.jpg', slug: 'hwanghyunjoo', }
			] }
    ],
    streets: [
      '가로수길', '동대문', '명동', '서면', '이태원', '홍대입구', '시부야', '신주쿠', '하라주쿠'
    ]
  },

  /**
   * 팝업 관련 Props
   *
   * @isOpened       {Boolean} : 팝업 열림 상태
   *
   * @activeFilter   {Boolean} : 메인 피드 필터의 성별 선택 상태
   * @selectedGender {String}  : 선택된 성별
   *
   * @activeAlarm    {Boolean} : 알람 팝업 열림 상태
   * @alarmResult    {Array}   : 알람 리스트
   *
   * @activeSearch   {Boolean} : 검색 팝업 열림 상태
   * @searchResult   {Array}   : 검색 결과 리스트
   * @keyword        {String}  : 검색어
   */
  isOpened: false,
  downloadPopupHeight: 0,

  activeFilter: getQueryString('gender') ? true : false,
  selectedGender: inGenders(getQueryString('gender')),

  activeAlarm: false,
  alarmResult: [],

  activeSearch: false,
  searchResult: [],
  searchType: '',
  keyword: '',
  activeKeyword: '',
  activeLocationId: 0,
  activeBrandId: 0,
  activeHashtagId: 0,

  /**
   * 피드 관련 Props
   *
   * @feeds            {Array}   : 피드 리스트
   * @feedIds          {Array}   : 피드 아이디
   * @popFeeds         {Array}   : 인기 피드 리스트
   * @popFeedIds       {Array}   : 인기 피드 아이디
   * @nextFeeds        {String}  : 다음 피드 리스트
   * @selectedFeed     {Element} : 열려 있는 피드
   * @selectedPopFeed  {Element} : 열려 있는 인기 피드
   * @feedComments     {Array}   : 열려 있는 피드의 댓글
   * @nextFeedComments {String}  : 다음 피드 댓글 리스트
   * @user             {Element} : 피드 혹은 커뮤니티 업로드 유저
   * @userPost         {Array}   : 유저가 최근 올린 포스트
   */
  feeds: [],
  feedIds: [],
  popFeeds: [],
  popFeedIds: [],
  nextFeeds: '',
  selectedFeed: null,
  selectedPopFeed: null,
  feedComments: [],
  nextFeedComments: '',
  user: null,
  userPost: [],

  /**
   * 커뮤니티 관련 Props
   *
   * @communities           {Array}   : 커뮤니티 리스트
   * @communityIds          {Array}   : 커뮤니티 아이디
   * @nextCommunities       {String}  : 다음 커뮤니티 리스트
   * @selectedCommunity     {Element} : 열려 있는 커뮤니티
   * @communityComments     {Array}   : 열려 있는 커뮤니티의 댓글
   * @nextCommunityComments {String}  : 다음 커뮤니티 댓글 리스트
   */
  communityIds: [],
  communities: [],
  nextCommunities: '',
  selectedCommunity: null,
  communityComments: [],
  nextCommunityComments: '',

  /**
   * 업로드 관련 Props
   *
   * @postId                     {Number}  : 포스트 ID
   * @attachIds                  {Array}   : 이미지 파일들 ID 리스트
   * @uploadMode                 {String}  : 업로드 형식 (general / editorial)
   * @uploadable                 {Boolean} : 업로드 가능 여부
   * @itemCategories             {Array}   : 핀 태깅을 위한 아이템 리스트
   * @uploadTarget               {String}  : 업로드 페이지 타겟 (image / detail)
   * @uploadForm                 {Array}   : 업로드 폼
   * @uploadedImageSize          {Object}  : 업로드 된 이미지의 사이즈
   * @activeCoordsElement:       {Array}   : 업로드 된 이미지 영역에서 핀 추가 상태를 나타냄
   * @activeCoords:              {Array}   : 업로드 된 이미지의 핀 좌표
   * @activeUploadBrand          {Boolean} : 이미지 업로드 시 브랜드 영역 활성화 여부 // Deprecated
   * @activeSearchedUploadBrands {Array}   : 이미지 업로드 시 브랜드 영역 활성화 여부
   * @activeUploadColor          {Array}   : 이미지 업로드 시 색상 영역 활성화 여부
   * @activeUploadLocation       {Boolean} : 업로드 시 지역 영역 활성화 여부
   * @uploadedPin                {Array}   : 핀 리스트 (2차원 배열)
   * @settedUploadBrand          {Array}   : 추가된 브랜드 리스트 (2차원 배열)
   * @searchedUploadBrands       {Array}   : 검색된 브랜드 리스트 (2차원 배열)
   * @selectedUploadBrands       {Array}   : 업로더가 선택한 브랜드 리스트 (2차원 배열)
   * @selectedUploadColors       {Array}   : 업로더가 선택한 색상 리스트 (2차원 배열)
   * @searchedUploadLocations    {Array}   : 업로더가 입력한 지역 리스트
   * @selectedUploadLocation     {String}  : 업로더가 입력한 지역 스트링
   */
  postId: 0,
  attachIds: [],
  uploadMode: 'general',
  uploadable: true,
  itemCategories: [],
  uploadTarget: 'image',
  uploadForm: [ {} ],
  uploadedImageSize: null,
  activeCoordsElement: [false],
  activeCoords: [ {} ],
  activeUploadBrand: [false],
  activeSearchedUploadBrands: [false],
  activeUpdateBrand: [false],
  activeSearchedUpdateBrands: [false],
  activeUploadColor: [false],
  activeUploadLocation: false,
  uploadedPin: [ [] ],
  settedUploadBrand: [ [] ],
  searchedUploadBrands: [ [] ],
  selectedUploadBrands: [ [] ],
  selectedUploadColors: [ [] ],
  searchedUploadLocations: [],
  selectedUploadLocation: '',

  /**
   * 마이페이지 관련 Props
   * @myProfile {Object} : 유저 프로필 정보
   */
  myProfile: {},

  /**
   * 검색어 추천 관련 Props
   * @explorerResult {Array} : 검색어 추천 결과 리스트
   */
  explorerResult: [],
  defaultExplorerResult: [ { image: '/assets/images/1.jpg', tag: 'A' }, { image: '/assets/images/2.jpg', tag: 'B' }, { image: '/assets/images/3.jpg', tag: 'C' },  { image: '/assets/images/4.jpg', tag: 'D' }, { image: '/assets/images/5.jpg', tag: 'E' } ],

  /**
   * 프로필 관련 Props
   */
  userProfile: null,
  userInformation: null,
  collectedImages: [],
  collectedImagesInDetail: [],
  userFollowing: 0,
  userFollower: 0,
  userFollowingList: [],
  userFollowerList: [],
  nextUserFollower: '',
  nextUserFollowing: '',
  nextCollection: '',
  nextCollectionInDetail: '',
  totalPost: 0,
  totalScrap: 0,
  refreshCollection: true,

  /**
   * Location 관련 Props
   */
  location: null,
  locationImages: [],
  locationFollowing: 0,
  locationFollower: 0,
  locationFollowingList: [],
  locationFollowerList: [],
  nextLocationFollower: '',
  nextLocationFollowing: '',
  nextLocationCollection: '',
  totalLocationPost: 0,

  /**
   * Hashtag 관련 Props
   */
  hashtag: null,
  hashtagImages: [],
  hashtagFollowing: 0,
  hashtagFollower: 0,
  hashtagFollowingList: [],
  hashtagFollowerList: [],
  nextHashtagFollower: '',
  nextHashtagFollowing: '',
  nextHashtagCollection: '',
  totalHashtagPost: 0,

  /**
   * Brand 관련 Props
   */
  brand: null,
  brandImages: [],
  brandFollowing: 0,
  brandFollower: 0,
  brandFollowingList: [],
  brandFollowerList: [],
  nextBrandFollower: '',
  nextBrandFollowing: '',
  nextBrandCollection: '',
  totalBrandPost: 0,

  /**
   * 아이템 관련 Props
   */
  pinnedItems: [],

  /**
   * 앱 스토어 및 딥링크
   */
  playStore: 'https://play.google.com/store/apps/details?id=kr.camscon.camsconapp',
  appStore: 'https://itunes.apple.com/us/app/kaemseukon-camscon/id1156796311?l=ko&ls=1&mt=8',
  iosDeepLink: '',
  andDeepLink: '',





  isLogon: function () {
    var returnData;
    if (!process.browser) return true;
    returnData = (localStorage[defaultStates.localStorageKey] ? true : false);

    // alert("isLogon2: "+ returnData);
    return returnData;
  }


};

export default defaultStates;

